<template>
  <div>
    <md-card class="round-corners">
      <md-card-header>
        <div class="md-title">
          {{ questionnaire.title }}
          <md-icon class="md-size-1x md-primary" v-if="certified"
            >verified</md-icon
          >
          <md-icon
            class="md-size-1x md-primary"
            v-if="qualified && !certified"
          ></md-icon>
          <md-icon
            class="md-size-1x md-primary"
            v-else-if="!inProcess && !qualified && !certified"
            >fiber_new</md-icon
          >
        </div>
        <div class="md-subhead">
          {{ questionnaire.discipline }} | {{ sumOfQuestions }} Fragen
        </div>
      </md-card-header>
      <md-card-content>
        <QuestionnaireStats
          v-if="inProcess && !qualified"
          :questionnaire="questionnaire"
        />
      </md-card-content>
      <md-card-actions>
        <div v-if="certified">
          <md-button
            v-if="stats.scores[0] + stats.scores[1] + stats.scores[2] > 0"
            :to="`/${questionnaire.identifier}`"
            >Weiter Lernen</md-button
          >
          <md-button :to="`/${questionnaire.identifier}/certificate`"
            >Zertifikat anzeigen</md-button
          >
        </div>
        <div v-else-if="inProcess && !qualified && !certified">
          <md-button :to="`/${questionnaire.identifier}`"
            >Weiter Lernen</md-button
          >
        </div>
        <div v-else-if="qualified && !certified">
          <md-button :to="`/${questionnaire.identifier}`"
            >Weiter Lernen</md-button
          >
          <md-button
            :to="`/${questionnaire.identifier}`"
            class="md-raised md-primary"
            >Zertifikat erstellen</md-button
          >
        </div>
        <div v-else-if="!inProcess && !qualified">
          <md-button :to="`/${questionnaire.identifier}`">Lernen</md-button>
        </div>
      </md-card-actions>
      <pre v-if="inDevelopment" style="color: #f00;">{{ stats }}</pre>
    </md-card>
  </div>
</template>
<script>
import QuestionnaireStats from "./QuestionnaireStats.vue";
export default {
  props: {
    questionnaire: {
      type: Object,
      required: true,
    },
  },
  components: {
    QuestionnaireStats,
  },
  computed: {
    stats() {
      return (
        this.$store.getters[`${this.questionnaire.identifier}/stats`] || {}
      );
    },
    sumOfQuestions() {
      return (
        this.stats.scores[0] +
        this.stats.scores[1] +
        this.stats.scores[2] +
        this.stats.scores[3]
      );
    },
    certified() {
      return this.$store.state[this.questionnaire.identifier].certificate;
    },
    qualified() {
      return this.stats.qualified;
    },
    inProcess() {
      const scores = this.stats.scores || [];
      return scores[1] + scores[2] + scores[3] > 0;
    },
    inDevelopment() {
      return process.env.NODE_ENV !== "production";
    },
  },
};
</script>
<style lang="scss">
.round-corners {
  border-radius: 0.5em;
}
.not-available .md-title {
  color: red;
}
</style>
